import store from '@/store/index'

export const isManagerGuard = (redirectPath) => (to, from, next) => {
  if (!store.getters['auth/isManager']) {
    store.commit('notify/set', {message: '許可されていないアクションです'})
    next(redirectPath)
    return
  }
  next()
}

export const availablePathNamesForParentMember = ['events', 'settings', 'members', 'goalList', 'mandalaEvaluation']
